import { ArrowRightIcon } from "@talladega/icons";
import { GetBackgroundStyle, IsNodeStructure } from "@talladega/helpers";
import { ActionButton } from "@talladega/types";
import classNames from "classnames";
import { useState } from "react";
import { CmsHeading } from "../CmsHeading";
import { HeroHeadingLayout } from "./HeroHeadingLayout";

export const HeroHeading = ({
  heroHeading,
  heroSubheading,
  heroImage,
  imagePosition,
  button,
  background,
  htmlIdRef,
  cmsButton,
  cmsHeroImage,
  cmsButtonModalContainer,
  baseDomain,
}: HeroHeadingLayout) => {
  const [buttonModalState, setButtonModalState] = useState<{
    show: boolean;
    actionType: ActionButton;
  }>({ show: false, actionType: ActionButton.UnAssigned });

  const { altText, sourceUrl } =
    (IsNodeStructure(heroImage) ? heroImage.node : heroImage) ?? {};

  return (
    <div
      id="cms-hero-heading"
      className="no-scrollbar relative overflow-visible bg-white bg-cover bg-center"
      style={GetBackgroundStyle(background, baseDomain)}
    >
      <div
        className={classNames(
          "relative mx-auto flex max-w-page flex-col-reverse items-center px-4 pb-6 pt-10 lg:px-5 lg:py-16",
          {
            "lg:flex-row": imagePosition === "Right",
            "lg:flex-row-reverse": imagePosition === "Left",
          }
        )}
      >
        <div className="flex-1 md:px-28 lg:basis-[40%] lg:px-0">
          <div>
            <div className="w-full text-center sm:items-start sm:justify-start sm:text-left">
              {heroHeading && (
                <CmsHeading
                  headingLevel={heroHeading.headingGroup?.headingLevel}
                  textSize={heroHeading.headingGroup?.textSize}
                  text={heroHeading.headingGroup?.text}
                  htmlId={heroHeading.headingGroup?.htmlId}
                />
              )}
            </div>

            <div className="mt-2 w-full items-center justify-center text-center sm:items-start sm:justify-start sm:text-left">
              <div className="mt-4 lg:mt-8">
                {heroSubheading && (
                  <CmsHeading
                    headingLevel={heroSubheading.headingGroup?.headingLevel}
                    textSize={heroSubheading.headingGroup?.textSize}
                    text={heroSubheading.headingGroup?.text}
                    htmlId={heroSubheading.headingGroup?.htmlId}
                  />
                )}
              </div>
            </div>

            {button && !button.isHidden && (
              <div className="mt-8 items-center justify-center text-center sm:items-start sm:justify-start sm:text-left">
                {cmsButton(
                  setButtonModalState,
                  button,
                  htmlIdRef,
                  <ArrowRightIcon />
                )}
              </div>
            )}
          </div>
        </div>
        <div className="relative w-full flex-1 lg:basis-[60%]">
          <div className="relative inset-0 h-auto min-w-full">
            <div className="relative h-56 overflow-auto md:h-96">
              {heroImage &&
                sourceUrl &&
                cmsHeroImage({
                  src: sourceUrl,
                  alt: altText,
                })}
            </div>
          </div>
        </div>
      </div>
      {buttonModalState.show && cmsButtonModalContainer(buttonModalState)}
    </div>
  );
};

export default {};
